import React, { useEffect } from "react";
import { KeywordCombinations, LogoData } from "../lib/types";
import { useContext } from "react";
import { KeywordsContext } from "../Home";
import { textLogoLimit } from "../lib/api";
import LogoContainer from "./LogoContainer";
import TextNameContainer from "./TextNameContainer";

type LogosOrTextProps = {
  useTextLogos: boolean | undefined,
  index: number,
  item: KeywordCombinations | null,
  textLogoUrls: LogoData[],
  randomOffset: number,
  onClick: (word: string, keywords: string[], selectedTextLogo: LogoData | undefined) => void
}

const LogosOrText = (props: LogosOrTextProps) => {
  const { useTextLogos, index, item } = props
  const keywords = useContext(KeywordsContext)

  const onNameItemClick = (word: string, keywords: string[], index: number) => {
      let logoData;
      if (props.useTextLogos) {
          const logoIndex = (index + props.randomOffset) % textLogoLimit
          logoData = props.textLogoUrls[logoIndex]
      }
      props.onClick(word, keywords, logoData)

  }


  const getLogoUrl = (companyName: string, index: number) => {
      // TODO: handle FLC here
      const logoIndex = (index + props.randomOffset) % textLogoLimit
      const url = `${props.textLogoUrls[logoIndex].img_url.split("?")[0]}?company=${encodeURIComponent(companyName)}`
      return url
  }
  if (useTextLogos) {
      return (
          <LogoContainer
              isLoaded={true}
              onClick={() => onNameItemClick(item?.word || "", item?.keywords || [], index)}

              src={getLogoUrl(item?.word || "company", index)}
              onLoad={() => {}}
              index={index} />
      )
  } else {
      return (
          <TextNameContainer
              randomOffset={props.randomOffset}
              index={index}
              onClick={() => onNameItemClick(item?.word || "", item?.keywords || [], index)}
              item={item}
          />
      )
  }
}

export default React.memo(LogosOrText)